import EmptyState from "@/components/EmptyState";

export default function PastMemberElectionsContent() {
  return (
    <div className="pt-12">
      <EmptyState
        iconName="history"
        title="Past elections coming soon"
        caption="Election run history will appear here after the backend API is available."
      />
    </div>
  );
}
